import { useCallback, useMemo, useState, type ReactNode } from 'react';

import { NETWORK_SCOPE, statsScopeKey, type StatsScope } from '@/components/map/utils/resolveStatsScope';
import { StatsScopeContext } from './StatsScopeContext';

/**
 * Bridges the map-centre stats scope from MapView (inside the route <Outlet>) up
 * to the Global Stats bar in the Find & Fix layout. Scoped to that layout, like
 * ExclusivePanelProvider. setScope bails out when the scope key is unchanged so
 * the repeated resolutions fired on every settled pan cause no re-render churn.
 */
export function StatsScopeProvider({ children }: { children: ReactNode }) {
    const [scope, setScope] = useState<StatsScope>(NETWORK_SCOPE);

    const publishScope = useCallback((next: StatsScope) => {
        setScope((current) => (statsScopeKey(current) === statsScopeKey(next) ? current : next));
    }, []);

    const value = useMemo(() => ({ scope, setScope: publishScope }), [scope, publishScope]);

    return <StatsScopeContext value={value}>{children}</StatsScopeContext>;
}
